<loading-animated *ngIf="!this.flagIa && isLoading$ | async"></loading-animated>
<div class="wrapper-stepper">
    <div class="upper-bar">
        <h2>
            <button class="btn btn-link" style="color: white; font-size: inherit !important" cdkStepperPrevious>
                <i class="far fa-chevron-left" style="cursor: pointer"></i>
            </button>
            {{ 'app.wizard.upper_bar.contacto' | translate }}
        </h2>
    </div>
    <div class="py-5 px-4">
        <div class="title-template">
            <h2
                class="color-secundario mb-3"
                [innerHTML]="'app.wizard.social_media.que_datos_de_contacto' | translate"
            ></h2>
            <p class="subtitle-content color-texto2">
                {{ 'app.wizard.social_media.completa_esta_informacion_para_que' | translate }}
            </p>
        </div>
        <!-- <div class="w-100 scroll-y-auto mb-4"> -->
        <!-- scroll-y-auto genera scroll con los select de pais -->
        <div class="w-100 mb-4">
            <form
                class="main-form h-100"
                [formGroup]="contactDataForm"
                (ngSubmit)="onFormSubmit()"
                *ngIf="contactDataForm"
            >
                <div class="d-flex h-100 contact-form">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 p-0 pr-sm-3">
                        <!-- Email de contacto -->
                        <div class="col-12 p-0 mb-2">
                            <mc-form-group-input
                                [form]="contactDataForm"
                                name="email"
                                [label]="'app.wizard.social_media.email_de_contacto' | translate"
                                class.form-control-lg="size == 'lg'"
                                class.form-control-sm="true"
                                ngClass="{ 'is-invalid': submitted && controlInvalid }"
                                [submitted]="submitted"
                                [sublabel]="'app.wizard.social_media.este_campo_es_obligatorio' | translate"
                                [placeholder]="'app.wizard.social_media.ejemplo@email.com' | translate"
                            >
                            </mc-form-group-input>
                        </div>
                        <!-- Número para llamadas -->
                        <div class="col-12 p-0 form-group label-input-nro mb-3">
                            <label for="">{{ 'app.wizard.social_media.numero_para_llamadas' | translate }}</label>
                            <div class="d-flex flex-wrap align-items-start">
                                <div class="p-0 pr-1 pr-sm-2">
                                    <mc-select-cod-country
                                        [idSelect]="'countryCodePhone'"
                                        [defaultCountry]="
                                            (countryCodePhoneNumber$ | async)
                                                ? (countryCodePhoneNumber$ | async)
                                                : defaultCountryFlag
                                        "
                                        (countrySelected)="selectCountryCodePhone($event)"
                                        [countries]="languagesCountries$ | async"
                                        [nameKey]="'iso_code_2'"
                                    ></mc-select-cod-country>
                                </div>
                                <div class="col p-0">
                                    <mc-form-group-input
                                        autocomplete="chrome-off"
                                        name="phone"
                                        type="number"
                                        [form]="contactDataForm"
                                        [submitted]="submitted"
                                        placeholder="11 62064589"
                                        [numericCodeNumber]="
                                            countryCodePhone?.prefix_phone ?? defaultCountryFlag.prefix_phone
                                        "
                                        ngClass="{ 'is-invalid': controlInvalid }"
                                    >
                                    </mc-form-group-input>
                                </div>
                            </div>
                        </div>
                        <!-- Número para whatsapp -->
                        <div class="col-12 p-0 form-group label-input-nro mb-3">
                            <label for="">{{ 'app.wizard.social_media.numero_para_whatsapp' | translate }}</label>
                            <div class="d-flex flex-wrap align-items-start">
                                <div class="p-0 pr-1 pr-sm-2">
                                    <mc-select-cod-country
                                        [idSelect]="'countryCodeWp'"
                                        [defaultCountry]="
                                            (countryCodeWp$ | async) ? (countryCodeWp$ | async) : defaultCountryFlag
                                        "
                                        (countrySelected)="selectCountryCodeWp($event)"
                                        [countries]="languagesCountries$ | async"
                                        [nameKey]="'iso_code_2'"
                                    ></mc-select-cod-country>
                                </div>
                                <div class="col p-0">
                                    <mc-form-group-input
                                        [form]="contactDataForm"
                                        name="whatsapp"
                                        type="number"
                                        class.form-control-lg="size == 'lg'"
                                        class.form-control-sm="true"
                                        ngClass="{ 'is-invalid': submitted && controlInvalid }"
                                        [submitted]="submitted"
                                        autocomplete="chrome-off"
                                        [numericCodeNumber]="
                                            countryCodeWp?.prefix_phone ?? defaultCountryFlag.prefix_phone
                                        "
                                        placeholder="11 62064589"
                                    >
                                    </mc-form-group-input>
                                </div>
                            </div>
                        </div>
                        <!-- Redes sociales -->
                        <div class="d-flex flex-column" formArrayName="socialMedia">
                            <label for="" class="position-relative color-texto mt-3 mt-lg-2 mt-xl-1 label-redes">{{
                                'app.wizard.social_media.redes_sociales' | translate
                            }}</label>
                            <div class="social-container">
                                <ng-container *ngFor="let item of getSocialMedia.controls; let i = index">
                                    <div class="d-flex flex-row bd-highligh input-group">
                                        <div class="position-relative col-11 col-md-11 p-0">
                                            <i
                                                class="input-social-group-left-icon"
                                                [ngClass]="
                                                    socialMediaHelper.socialExist(item.value)
                                                        ? socialMediaHelper.socialExist(item.value).icon
                                                        : 'fal fa-globe default-icon'
                                                "
                                            ></i>
                                            <input
                                                [ngStyle]="{
                                                    'padding-left': socialMediaHelper.socialExist(item.value)
                                                        ? '2.8rem'
                                                        : '1rem'
                                                }"
                                                class="form-control border border-end-0 rounded pr-5 mb-2"
                                                [ngClass]="
                                                    item.value
                                                        ? item.valid
                                                            ? 'border-green'
                                                            : 'border-red'
                                                        : !item.pristine
                                                        ? item.value
                                                            ? item.valid
                                                                ? 'border-green'
                                                                : 'border-red'
                                                            : ''
                                                        : ''
                                                "
                                                type="text"
                                                [formControlName]="i"
                                                [label]="'app.wizard.social_media.redes_sociales' | translate"
                                                #inputElement
                                                [placeholder]="'app.wizard.social_media.www.ejemplo.com' | translate"
                                            />
                                            <i
                                                class="input-social-group-validation-icon"
                                                [ngClass]="
                                                    item.value
                                                        ? item.valid
                                                            ? 'fal fa-check-circle text-success'
                                                            : 'fal fa-times-circle text-danger'
                                                        : !item.pristine
                                                        ? item.value
                                                            ? item.valid
                                                                ? 'fal fa-check-circle text-success'
                                                                : 'fal fa-times-circle text-danger'
                                                            : ''
                                                        : ''
                                                "
                                            ></i>
                                            <i
                                                class="fal fa-trash ml-2 color-texto position-absolute social-trash"
                                                (click)="deleteSocialNetwork(i)"
                                                [style.color]="
                                                    i === 0 && getSocialMedia.controls.length <= 1 ? '#bdbdbd' : '#666'
                                                "
                                            ></i>
                                        </div>

                                        <div class="invalid-tooltip position-relative d-block pl-0" *ngIf="item.errors">
                                            <small *ngIf="item.errors.isNotSocial">{{
                                                'app.errores.esta_url_no_es_valida' | translate
                                            }}</small>
                                            <small *ngIf="item.errors.required">{{
                                                'app.errores.este_campo_debe_completarse_o_eliminarse' | translate
                                            }}</small>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="d-flex justify-content-end w-100 mt-2 col-11 col-md-12 p-0">
                                <a
                                    class="mt-1 add-social-link"
                                    [ngClass]="
                                        getSocialMedia.controls[0].value
                                            ? getSocialMedia.status == 'VALID'
                                                ? 'color-link'
                                                : getSocialMedia.dirty && getSocialMedia.controls[0].value
                                                ? 'color-link'
                                                : 'color-link-disabled'
                                            : 'color-link-disabled'
                                    "
                                    (click)="addSocialNetwork()"
                                    >{{ 'app.wizard.social_media.agregar_otra_red_social' | translate }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="address col-12 col-sm-12 col-md-6 col-lg-6 pr-0 pl-3">
                        <div class="title-template">
                            <span>
                                {{ 'app.wizard.social_media.direccion' | translate }}
                            </span>
                            <span class="subtitle-content color-texto2">
                                {{ 'app.wizard.social_media.utiliza_el_orden' | translate }}
                            </span>
                        </div>
                        <div class="mapouter">
                            <iframe class="w-100" frameborder="0" scrolling="no" [src]="direction | safe"></iframe>
                        </div>
                        <div formArrayName="addressess">
                            <div class="addreess-container">
                                <ng-container *ngFor="let item of getaddressess?.controls; let i = index">
                                    <div class="input-group">
                                        <div
                                            class="input-social-group input-address-group d-flex align-items-center p-0"
                                            [ngStyle]="{
                                                width: (isMobile$ | async) ? 'calc(100dvw - 40px)' : '65dvw'
                                            }"
                                        >
                                            <div class="col-10">
                                                <input
                                                    [ngStyle]="{
                                                        'padding-left': '1rem'
                                                    }"
                                                    class="form-control input-social-group-link"
                                                    [ngClass]="
                                                        item.value?.length
                                                            ? 'addreess-input-checked'
                                                            : !item.value?.length &&
                                                              (item.dirty || item.touched) &&
                                                              i !== 0
                                                            ? 'addreess-input-denied'
                                                            : ''
                                                    "
                                                    type="text"
                                                    [formControlName]="i"
                                                    #addressInputElement
                                                    (input)="changeAddress($event.target.value)"
                                                />
                                                <i
                                                    class="input-social-group-validation-icon"
                                                    [ngClass]="
                                                        item.value?.length
                                                            ? 'fal fa-check-circle addreess-checked'
                                                            : !item.value?.length &&
                                                              (item.dirty || item.touched) &&
                                                              i !== 0
                                                            ? 'fal fa-times-circle addreess-denied'
                                                            : ''
                                                    "
                                                ></i>
                                            </div>
                                            <div class="col-2">
                                                <div class="d-flex">
                                                    <div class="col-6">
                                                        <span class="address-icon">
                                                            <i
                                                                class="fal fa-trash ml-2 addreess-trash mr-3"
                                                                (click)="deleteAddress(i)"
                                                                [style.color]="
                                                                    i === 0 && getAddressess?.controls.length <= 1
                                                                        ? '#bdbdbd'
                                                                        : '#666'
                                                                "
                                                            ></i>
                                                        </span>
                                                    </div>
                                                    <div class="col-6">
                                                        <span class="address-icon">
                                                            <i
                                                                class="fa-solid fa-location-dot ml-2 addreess-trash mapouter"
                                                                (click)="setAddressPin(i)"
                                                                [style.color]="'#666'"
                                                            ></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="invalid-tooltip-social ml-2"
                                            *ngIf="!item.value?.length && (item.dirty || item.touched) && i !== 0"
                                        >
                                            <small>{{
                                                'app.configuracion.este_campo_debe_completarse_o_eliminarse' | translate
                                            }}</small>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="d-flex align-items-center justify-content-end mt-3">
                                <a
                                    class="add-address-link"
                                    [ngClass]="allAddressesFilled ? 'color-link' : 'color-link-disabled'"
                                    (click)="addAddress()"
                                >
                                    {{ 'app.configuracion.agregar_otra_direccion' | translate }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="btn-div px-4">
        <button class="btn btn-link color-link back-btn" cdkStepperPrevious>
            <i class="fas fa-chevron-left mr-1"></i>{{ 'app.global.modals.volver' | translate }}
        </button>
        <div class="h-100" *ngIf="!flagIa">
            <button [disabled]="!this.contactDataForm?.valid" (click)="onFormSubmit()" class="btn btn-continue">
                {{ 'app.global.modals.finalizar' | translate }}
            </button>
        </div>
        <div class="h-100" *ngIf="flagIa">
            <button [disabled]="!this.contactDataForm?.valid" (click)="onFormSubmit()" class="btn btn-continue">
                <i class="fas fa-sparkles"></i>
                {{ 'app.wizard.stepper_ia.generar-sitio' | translate }}
            </button>
        </div>
    </div>
</div>
